// extracted by mini-css-extract-plugin
module.exports = {"email":"UserInfo_email__jq8WJ","containerUser":"UserInfo_containerUser__1lsLL","firstLetter":"UserInfo_firstLetter__29kq8"};